import { RecordType, CRM_ACTIONS, CRM_ACTION_TYPES } from 'rcx_adapter';

export const defaultHistoryMenuConfig = [
    {
        action: {
            name: CRM_ACTIONS.CRM_CREATE_RECORD,
            params: {
                type: RecordType.ACCOUNT,
            },
        },
        labelKey: 'menu.new_account',
    },
    {
        action: {
            name: CRM_ACTIONS.CRM_CREATE_RECORD,
            params: {
                type: RecordType.CONTACT,
            },
        },
        labelKey: 'menu.new_contact',
    },
    {
        action: {
            name: CRM_ACTIONS.CRM_CREATE_RECORD,
            params: {
                type: RecordType.CONSUMER,
            },
        },
        labelKey: 'menu.new_consumer',
    },
    {
        action: {
            name: CRM_ACTIONS.CRM_CREATE_RECORD,
            params: {
                type: RecordType.CASE,
            },
        },
        labelKey: 'menu.new_case',
    },
    {
        action: {
            name: CRM_ACTIONS.CRM_CREATE_RECORD,
            params: {
                type: RecordType.CASE_TASK,
            },
        },
        labelKey: 'menu.new_case_task',
    },
    {
        action: {
            name: CRM_ACTION_TYPES.CALL_BACK,
        },
        labelKey: 'menu.call_back',
    },
];

export const incidentHistoryMenuConfig = [
    {
        action: {
            name: CRM_ACTIONS.CRM_CREATE_RECORD,
            params: {
                type: RecordType.CONTACT,
            },
        },
        labelKey: 'menu.new_contact',
    },
    {
        action: {
            name: CRM_ACTION_TYPES.CALL_BACK,
        },
        labelKey: 'menu.call_back',
    },
];
